import { render, staticRenderFns } from "./sectionPersonelListWeb2.vue?vue&type=template&id=7ac26174&"
import script from "./sectionPersonelListWeb2.vue?vue&type=script&lang=js&"
export * from "./sectionPersonelListWeb2.vue?vue&type=script&lang=js&"
import style0 from "./sectionPersonelListWeb2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
